<template>
  <div class="edit_dev">
    <el-transfer
      v-model="formData.vehicleCodeList"
      :data="allData"
      filterable
      :titles="['待选车辆', '已选车辆']"
      :props="{ key: 'vehicleCode', label: 'vehicleNo', disabled: 'disabled' }"
      @change="onChange"
    >
      <span slot-scope="{ option }">{{ option.vehicleNo }}</span>
    </el-transfer>
  </div>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    driverCode: String,
    carrierCode: String,
  },
  data() {
    return {
      allData: [],
      formData: {
        driverCode: this.driverCode,
        vehicleCodeList: [],
      },
    }
  },
  mounted() {
    this.getData()
    this.getVehicle()
  },
  watch:{
    carrierCode(){
      this.getData()
      this.getVehicle()
    }
  },
  methods: {
    getData() {
      this.$api
        .masterVehicleModelListApi({ vehicleStatusList: ['Y'], carrierCode: this.carrierCode})
        .then((res) => {
          this.allData = res.body.data.map((t) => {
            return { ...t, disabled: this.disabled }
          })
        })
    },
    getVehicle() {
      this.$api
        .masterDriverVehicleListApi({ driverCode: this.driverCode })
        .then((res) => {
          const data = res.body.data
          if (!data) return
          this.formData.vehicleCodeList = data.map((t) => t.vehicleCode)
        })
    },
    onChange() {
      this.$api.masterDriverVehicleDriverAddApi(this.formData).then((res) => {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success',
        })
      })
    },
  },
}
</script>
<style scoped>
.edit_dev >>> .el-transfer-panel {
  width: 40%;
}
</style>
